export const currency = "€";
